import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { disableModalDiagramQuickShare } from '../../../redux/main/main.actions';
import { selectIsModalDiagramQuickShareEnabled, selectModalDiagramQuickShareData, selectDiagramDetails } from '../../../redux/main/main.selectors';

import { selectScale, selectOriginXY, selectElements, selectLines, selectAreas } from '../../../redux/diagram/diagram.selectors';

import { showNotify } from '../../../redux/notify/notify.actions';

import Modal from '../Modal/Modal';
import './ModalDiagramQuickShare.scss';

import { encode } from '../../../utils/quick-share/quick-share-encode';

export const ModalDiagramQuickShare = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const isOpen = useSelector(selectIsModalDiagramQuickShareEnabled);
    const modalData = useSelector(selectModalDiagramQuickShareData);

    const diagramDetails = useSelector(selectDiagramDetails);

    const scale = useSelector(selectScale);
    const originXY = useSelector(selectOriginXY);

    const elements = useSelector(selectElements);
    const lines = useSelector(selectLines);
    const areas = useSelector(selectAreas);


    const textareaRef = useRef(null);
    const [value, setValue] = useState('');

    useEffect(() => {
        if (isOpen && diagramDetails && scale && originXY && elements && lines && areas) {
            const [code, isError] = encode(diagramDetails, scale, originXY, elements, lines, areas);
            if (isError) {
                dispatch(showNotify({ message: 'something_wrong_contact' }));
            }

            const baseUrl = window.location.origin; // const baseUrl = 'https://playground.dbdesign.io';
            const encoded = encodeURIComponent(code);
            const path = `${baseUrl}/quick-share?q=${encoded}`;
            setValue(path);
        }
        return () => { };
    }, [
        isOpen,
        diagramDetails,
        scale,
        originXY,
        elements,
        lines,
        areas,
    ]);

    const handleCancel = () => {
        dispatch(disableModalDiagramQuickShare(null));
    };

    const handleCopyLink = async (e) => {
        try {
            await navigator.clipboard.writeText(value);
            dispatch(showNotify({ message: 'link_copied' }));
        } catch (err) { }
    }

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-quick-share`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_quick_share.title')} <span>{t('m_quick_share.subtitle')}</span></div>
            <div className="modal-content-body">
                <textarea
                    // disabled
                    readOnly
                    maxLength={1000}
                    ref={textareaRef}
                    autoComplete="off"
                    autoFocus={(window.innerWidth >= 1000)}
                    spellCheck="false"
                    value={value}
                    onClick={() => handleCopyLink()}
                />
                <button
                    onClick={() => handleCopyLink()}>
                    {/* <svg width="17" height="17" fill="none" viewBox="0 0 24 24" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: '1px' }}>
                        <path d="M8 8V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 2 10.08 2 11.2 2h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 16 19.92 16 18.8 16H16M5.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.48 16 19.92 16 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 8 13.92 8 12.8 8H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 9.52 2 10.08 2 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22"></path>
                    </svg> */}
                    <span>{t('b.copy_link')}</span>
                </button>
            </div>
        </Modal>
    );
};

export default ModalDiagramQuickShare;
